module.exports = __webpack_public_path__ + "static/img/全球司库管理云4.b25a3355.png";